import { z } from "zod";

export const createListingDraftSchema = z.object({
  analysisId: z.string().cuid().optional(),
  projectId: z.string().cuid().optional(),
  title: z
    .string()
    .min(1, "Başlık zorunludur")
    .max(140, "Başlık en fazla 140 karakter olabilir"),
  description: z
    .string()
    .min(1, "Açıklama zorunludur")
    .max(10000, "Açıklama çok uzun"),
  tags: z
    .array(z.string().max(20))
    .max(13, "En fazla 13 tag eklenebilir")
    .default([]),
  price: z.number().positive().optional(),
  quantity: z.number().int().min(1).default(1),
  taxonomyId: z.number().int().optional(),
  whoMade: z.string().default("i_did"),
  whenMade: z.string().default("made_to_order"),
  isSupply: z.boolean().default(false),
  listingType: z.string().default("physical"),
  shippingProfileId: z.string().optional(),
  sectionId: z.string().optional(),
  imageUrls: z.array(z.string()).default([]),
  videoUrl: z.string().nullable().optional(),
  /** Verilirse taslagin urun fotograflarindan slayt videosu arka planda uretilir
   *  (taslakta video yoksa ya da gorseller degistiyse) */
  video: z.object({
    aspectRatio: z.enum(["1:1", "16:9", "9:16"]).optional(),
    duration: z.union([z.literal(6), z.literal(8)]).optional(),
    zoomPercent: z.number().min(0).max(15).optional(),
  }).optional(),
  variations: z.any().optional(),
  disabledCombos: z.any().optional(),
  personalization: z.any().optional(),
  etsyListingId: z.string().optional(),
  scheduledAt: z.string().datetime().optional(),
  templateId: z.string().optional(),
  mockupTemplates: z.array(z.string()).optional(),
  sku: z.string().nullable().optional(),
  category: z.string().nullable().optional(),
  whatIsIt: z.string().nullable().optional(),
  isDigital: z.boolean().optional(),
  autoRenew: z.boolean().optional(),
  isFeatured: z.boolean().optional(),
  materials: z.array(z.string()).optional(),
  attributes: z.any().optional(),
  returnPolicyId: z.string().nullable().optional(),
  processingProfileId: z.string().nullable().optional(),
  productionPartnerId: z.string().nullable().optional(),
});

export type CreateListingDraftInput = z.input<typeof createListingDraftSchema>;

export const updateListingDraftSchema = z.object({
  title: z.string().min(1).max(140).optional(),
  description: z.string().min(1).max(10000).optional(),
  tags: z.array(z.string().max(20)).max(13).optional(),
  price: z.number().positive().optional(),
  status: z.enum(["draft", "ready", "published", "archived", "scheduled", "builder"]).optional(),
  quantity: z.number().int().min(1).optional(),
  taxonomyId: z.number().int().nullable().optional(),
  whoMade: z.string().optional(),
  whenMade: z.string().optional(),
  isSupply: z.boolean().optional(),
  listingType: z.string().optional(),
  shippingProfileId: z.string().nullable().optional(),
  sectionId: z.string().nullable().optional(),
  imageUrls: z.array(z.string()).optional(),
  videoUrl: z.string().nullable().optional(),
  /** Verilirse taslagin urun fotograflarindan slayt videosu arka planda uretilir
   *  (taslakta video yoksa ya da gorseller degistiyse) */
  video: z.object({
    aspectRatio: z.enum(["1:1", "16:9", "9:16"]).optional(),
    duration: z.union([z.literal(6), z.literal(8)]).optional(),
    zoomPercent: z.number().min(0).max(15).optional(),
  }).optional(),
  variations: z.any().optional(),
  disabledCombos: z.any().optional(),
  personalization: z.any().optional(),
  etsyListingId: z.string().nullable().optional(),
  scheduledAt: z.string().datetime().nullable().optional(),
  templateId: z.string().nullable().optional(),
  mockupTemplates: z.array(z.string()).optional(),
  sku: z.string().nullable().optional(),
  category: z.string().nullable().optional(),
  whatIsIt: z.string().nullable().optional(),
  isDigital: z.boolean().optional(),
  autoRenew: z.boolean().optional(),
  isFeatured: z.boolean().optional(),
  materials: z.array(z.string()).optional(),
  attributes: z.any().optional(),
  returnPolicyId: z.string().nullable().optional(),
  processingProfileId: z.string().nullable().optional(),
  productionPartnerId: z.string().nullable().optional(),
  views: z.number().int().min(0).optional(),
  favorites: z.number().int().min(0).optional(),
  sales: z.number().int().min(0).optional(),
});

export type UpdateListingDraftInput = z.infer<typeof updateListingDraftSchema>;

export const listingDraftIdSchema = z.object({
  id: z.string().cuid("Geçersiz listing draft ID"),
});
